import React from "react"
import OutsideClickTrigger from "../../booking/components/common/OutsideClickTrigger"
import PropTypes from "prop-types"
import Svg from "../../shared/_svgs/svg"

export default function TestimonialModal({ modalOpen, modalRichtext, modalQuote, closeHandler, tooltip }) {
  return (
    <div className="overlay overlay--modal overlay--fixed is-active">
      <div className="modal">
        <OutsideClickTrigger
          onOutsideClick={() => {
            closeHandler()
          }}
        >
          <React.Fragment>
            <button
              className="button button--icon js--close-modal"
              onClick={() => {
                closeHandler()
              }}
            >
              <span className="icon">
                <svg className="svg-icon svg-icon--close-new">
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                    &nbsp;
                  </use>
                </svg>
              </span>
            </button>
            <div className="modal__content__inner">
              <div className="modal__top">
                <div className="a--left">
                  {modalRichtext ? <div className="rich-text"> {modalRichtext} </div> : null}
                  {modalQuote ? (
                    <div className="quote">
                      <Svg iconName="quote" fillColor="white"></Svg> {modalQuote}{" "}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </React.Fragment>
        </OutsideClickTrigger>
      </div>
    </div>
  )
}

TestimonialModal.propTypes = {
  modalOpen: PropTypes.bool,
  modalRichtext: PropTypes.array,
  ModalQuote: PropTypes.string,
  closeHandler: PropTypes.func,
}
